
var sessionId="";
var name="";   //商铺名称
var uid=0;
var mode="";
var sign="";
var isLoginBack=false ;  //登录协议专用（是否返回）
var isLoginSucc=false;   // 是否已登录

var isBreakNetWork = false ;  //是否已返回数据
var isLoginFail  =false ;   // 是否登录失败
var isBack           = false;
var response="";
var ws = "";    //websocket
var actionProcessArry={"LoginWithMobileVerifyCode":LoginWithMobileVerifyCode,"LoginWithSessionId":LoginWithSessionId,"NotifyNewMessage":NotifyNewMessage};

var httpSendQue=new Array();   //1.定义一个数组
var  id=0 ;  //生成一个随机数
var  configTime=500 ;  //两秒时间
var newConfigTime=8000;  //8秒

    function newIndicator(animata){

        animata()
    };

     //2.生成一个随机数
    function getHttpSendId()
    {
         var mydate = new Date()
         newId = mydate.getDay()+ mydate.getHours()+ mydate.getMinutes() + mydate.getSeconds() + mydate.getMilliseconds()+ Math.round(Math.random() * 10000);
         return newId
 
    }
     
    // 4.将生成ID放入数组
    function getArry(id){
        // var o={};
         httpSendQue[id] = 0; 
     }

    

     
    function reset()
    {
        sessionId="";
        uid=0;
        isLoginBack=false ;  //登录协议专用（是否返回）
        isLoginSucc=false;   // 是否已登录
    }

    function reconnect(){
        if(ws.readyState==1){
            return  
        }else if(ws.readyState==2 || ws.readyState==0){
                return
        }else if(ws.readyState==3){
            connect()
        }
    }

    function connect()
    {
        ws=new  WebSocket(wsUrl); 
        isLoginSucc = false;

        var newSid = '"' + "uid" + '":' + '"' + uid + '"';
        var newSessionId = '"' + "sessionId" + '":' + '"' + sessionId+ '"';
        ws.onopen=function(){
            if(uid>0 && sessionId.length>0){
                //  alert("ononpen"+uid+sessionId +"wsURL"+wsUrl)
                ws.send(
                '{"action":"LoginWithSessionId",' +newSid +"," +newSessionId +"}"
                );     
            }
        }
      ws.onmessage=function(res){
           isBack = true;
           disPatchMsg(res)
      }
      ws.onclose=function(){
        isLoginSucc = false;
        reconnect()   
      }
      ws.onerror=function(error){
        isLoginSucc = false;
         isBreakNetWork=true
         console.log("isBreakNetWork:"+isBreakNetWork)
        reconnect()   
      }
  }

  function disPatchMsg(res)
  {
      // alert(res.data)
      var newRes=JSON.parse(res.data)
    //   alert(newRes)
      response=newRes
    //   获取返回数据的action所对应的方法
      processFun = actionProcessArry[newRes.action];
      if (processFun){
        processFun(newRes)
      }else{
        // alert("未找到action"+newRes.action)
      }
    //   if(newRes.action=="NotifyNewMessage"){
    //     NotifyNewMessage(newRes)
    //   }
  }

function LoginWithMobileVerifyCode(newRes)
{
     isLoginBack=true      
}



function LoginWithSessionId (newRes)
{  
    if ( newRes.s == 0 || newRes.s == 1101 )
    {
        isLoginSucc = true;
        // alert("成功")
    }
    // 1102==>sessionID不正确  1103==>sessionID已过期需跳转到登录页面
    else if(newRes.s == 1102 || newRes.s == 1103)
    {
        isLoginFail=true ;
        // alert("重连登录失败1102，状态码：" + newRes.s +"uid:"+uid+",sessionid:"+sessionId)
        if (!isDev)
        {
            nativeStorageRemove("newObj");
        }
       
        // 等待五秒跳转到登录页面
        setTimeout(function(){
         // 弹框告诉用户，session已经过期，需要重新登录(未做)
            window.location.hash="#/HelloWorld"

        },5000)
      

    
    }
    else
    {
        // alert("重连登录失败else，状态码：" + newRes.s +"uid:"+uid+",sessionid:"+sessionId)
        
    }
}


function reLogin(){
    var newSid = '"' + "uid" + '":' + '"' + uid + '"';
    var newSessionId = '"' + "sessionId" + '":' + '"' + sessionId+ '"';

    if (ws.readyState!=1){
        reconnect();
    }
    else
    {
        if(uid>0 && sessionId.length>0){
            // alert("reLogin"+uid+sessionId)
            ws.send('{"action":"LoginWithSessionId",' +newSid +"," +newSessionId +"}" );     
        }
    }
}

function nativeStorageRemove(keyName){
    if(keyName.length>0){
         NativeStorage.remove(keyName, removeSuccess, removeError); 
    }
    
};

function removeSuccess()
{

};

function removeError()
{

};

function myAlert(msg)
{
    if ( isDebug )
    {
        // alert(msg);
    }
}



function NotifyNewMessage(res){
        document.getElementById("popup").style.display="block";  
        document.getElementById('tongzhi').innerText = res.subject;
        console.log("推送数据",res)
        console.log(window.location.hash,"=======",window.location.hash == "#/card" )
        if(window.location.hash == "#/card" ){
            console.log("页面跳转",response)
            document.getElementById("popup").style.display="none";  
            window.location.hash="#/myAlert?response="+response
        }

        if(res.type==0)
        {
            var a =  document.getElementById('type');
            a.innerHTML  =  "普通消息";
        }
        else if(res.type==1)
        {
            var a =  document.getElementById('type');
            a.innerHTML  =  "充值通知";
        }
        else if(res.type==2)
        {
            var a =  document.getElementById('type');
            a.innerHTML  =  "消费通知";
        }
        else if(res.type==3)
        {
            var a =  document.getElementById('type');
            a.innerHTML  =  "系统公告";
        }
        else if(res.type==4)
        {
            var a =  document.getElementById('type');
            a.innerHTML  =  "退款消息";
        }
       
        setTimeout(function(){
        document.getElementById("popup").style.display="none";  
        },4000)

}
function goTwo(response){
    console.log("点击传参",response)
    window.location.hash="#/kongbai?response="+response
    document.getElementById("popup").style.display="none"; 
    console.log(window.location.hash)
    var newUrl=window.location.hash.slice(0,7);
  
    // if(newUrl == "#/ceshi"){
    //     console.log("当前为ceshi页面")
    //     location.reload();
    // }
}
// 展开和折叠的动画






//////////////////
// WEBPACK FOOTER
// ./static/js/global.js
// module id = HEhi
// module chunks = 1